"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Crown } from "lucide-react";
import { FreemiumTrialEndsIn } from "@/components/layouts/premium-upgrade/freemium-trial-ends-in";
import { PremiumUpgradeDialogHost } from "@/components/layouts/premium-upgrade/premium-upgrade-dialog-host";
import { usePremiumUpgradeRequest } from "@/components/layouts/premium-upgrade/use-premium-upgrade-request";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
export function PremiumUpgradeHeaderCta() {
  const $ = _c(13);
  const {
    canRequestUpgrade,
    confirmUpgrade,
    dialogOpen,
    dialogPhase,
    freemiumTrialExpiresAt,
    handleDialogOpenChange,
    isSubmitting,
    openUpgradeDialog,
    organizationId
  } = usePremiumUpgradeRequest();
  const shouldRenderNothing = !organizationId || !canRequestUpgrade && !dialogOpen;
  if (shouldRenderNothing) {
    return null;
  }
  let t0;
  if ($[0] !== canRequestUpgrade || $[1] !== freemiumTrialExpiresAt || $[2] !== openUpgradeDialog) {
    t0 = canRequestUpgrade ? <div className={cn("flex items-stretch overflow-hidden rounded-md", "border border-border/50 bg-muted/25")}>{freemiumTrialExpiresAt ? <FreemiumTrialEndsIn expiresAt={freemiumTrialExpiresAt} /> : null}<Button className="rounded-none border-0 shadow-none h-6.5 text-xs sm:text-sm sm:h-7.5" onClick={openUpgradeDialog} size="sm" type="button"><Crown className="size-4" />Upgrade</Button></div> : null;
    $[0] = canRequestUpgrade;
    $[1] = freemiumTrialExpiresAt;
    $[2] = openUpgradeDialog;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  let t1;
  if ($[4] !== confirmUpgrade || $[5] !== dialogOpen || $[6] !== dialogPhase || $[7] !== handleDialogOpenChange || $[8] !== isSubmitting) {
    t1 = <PremiumUpgradeDialogHost confirmUpgrade={confirmUpgrade} dialogOpen={dialogOpen} dialogPhase={dialogPhase} handleDialogOpenChange={handleDialogOpenChange} isSubmitting={isSubmitting} />;
    $[4] = confirmUpgrade;
    $[5] = dialogOpen;
    $[6] = dialogPhase;
    $[7] = handleDialogOpenChange;
    $[8] = isSubmitting;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  let t2;
  if ($[10] !== t0 || $[11] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}